import { RouteObject } from "react-router-dom";
import { RolesList } from "../pages/admin/roles/RolesList";
import { RoleCreate } from "../pages/admin/roles/RoleCreate";
import { RoleDetail } from "../pages/admin/roles/RoleDetail";
import { RoleEdit } from "../pages/admin/roles/RoleEdit";

export const rolesRoutes: RouteObject[] = [
  {
    id: "roles-list",
    index: true,
    element: <RolesList />,
  },
  {
    id: "role-create",
    path: "create",
    element: <RoleCreate />,
  },
  {
    id: "role-detail",
    path: ":id",
    element: <RoleDetail />,
  },
  {
    id: "role-edit",
    path: ":id/edit",
    element: <RoleEdit />,
  },
];
